import { Product } from '@meitu/subscribe-core';
import { atom } from 'jotai';

/**
 * 加载二维码接口
 */
export const loadingAtom = atom<boolean>(true);

/**
 * 当前选中的商品处于第几位
 */
export const activeIndexAtom = atom<number>(-1);

/**
 * 当前选中的商品信息
 */
export const curProductAtom = atom<Product>((get) => get(productsAtom)[get(activeIndexAtom)]);

/**
 * 商品列表
 */
export const productsAtom = atom<Product[]>([]);

/**
 * 支付二维码URL
 */
export const qrCodeUrlAtom = atom<string>('');

/**
 * 支付成功的商品信息
 */
export const payProductInfoAtom = atom<any>();

/**
 * 席位数
 */
export const seatsAtom = atom<number>(0);
